import React from 'react';
import { useStyles, StyledTableCell, StyledTableRow } from './ACLStyle';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';
import SearchIcon from '../../../assets/icons/searchIcon.svg';
import ThreeDotsIcon from '../../../assets/icons/AclPageThreeDots.svg';
import RemoveIcon from '../../../assets/icons/removeIcon.svg';

export default function ACL({ headings, data }) {
    const styles = useStyles();
    const [searchVal, setSearchVal] = React.useState('');
    return (
        <div>
            <div className={styles.newAclEntryContainer}>
                <p className={styles.addNewAclEntryTxt}>Add a new ACL entry</p>
                <p className={styles.inputLabel}>Username</p>
                <input className={styles.inputField} type="text" />
                <p className={styles.inputLabel}>Topic</p>
                <input className={styles.inputField} type="text" />
                <p className={styles.inputLabel}>Permission</p>
                <input className={styles.inputField} placeholder='Admin' type="text" />
                <div className={styles.addBtnContainer}>
                    <button className={styles.addBtn}>Add ACL entry</button>
                </div>
            </div>
            <div className={styles.inputWithIconContainer}>
                <input onChange={(e) => setSearchVal(e.target.value)} className={styles.searchInput} type="text" placeholder='Search by name' />
                <div className={styles.iconContainer}>
                    <img src={SearchIcon} alt="icon" />
                </div>
            </div>
            <TableContainer component={Paper} className={styles.eventContainer} >
                <Table className={styles.table} size="medium" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {
                                headings?.map((item) => {
                                    return (
                                        <StyledTableCell >{item}</StyledTableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data?.filter((item) => {
                                if (item?.userName?.toLowerCase().includes(searchVal.toLowerCase())) {
                                    return item;
                                }
                            })?.map((item, index) => (
                                <StyledTableRow >
                                    <StyledTableCell >{item?.userName}</StyledTableCell>
                                    <StyledTableCell ><img src={ThreeDotsIcon} alt="dots-icon" /></StyledTableCell>
                                    <StyledTableCell ><button className={styles.permissionBtn}>Admin</button></StyledTableCell>
                                    <StyledTableCell ><img className={styles.removeIcon} src={RemoveIcon} alt="icon" /></StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
